import routeService from './routes'

export default routeService
